import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { PaymentMethod } from '../../../models/paymentMethod/paymentMethod';
import { PaymentMethodService } from '../../../models/paymentMethod/paymentMethodService';

@Component({
  selector: 'app-authorize-form',
  templateUrl: './authorize-form.component.html',
  standalone: false,
})
export class AuthorizeFormComponent {
  paymentMethod: PaymentMethod;

  constructor(
    public dialogRef: MatDialogRef<AuthorizeFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { paymentMethodId: string; customerId: string },
    public paymentMethodService: PaymentMethodService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    this.paymentMethod = new PaymentMethod({});
  }

  ngOnInit() {
    this.paymentMethodService
      .getPaymentMethod(this.data.paymentMethodId, this.data.customerId)
      .then((pm) => {
        this.paymentMethod = pm;

        if (this.paymentMethod == undefined) {
          this.paymentMethod = new PaymentMethod({});
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }
}
